/**
 * Configuration for tenants & UI
 * For Ui specific configuration, go into the specific UiConfig file -> /ui/../index.ts
 * This config is also used for the debug panel to show the list of tenants to choose from.
 */

// The group ID for the devTeam
export const devGroup = 'c007d5c0-eb25-4535-ab39-bb2d2cb9b3bf';

// The group ID for admins
export const adminGroup = 'bd5b0c35-0217-496a-ab3b-a0c5ab7c2ef7';

//What cookie key to use for storing the tenant key
export const TENANT_COOKIE_STORAGE_KEY = 'dev_tenant';

//what parameter to use for the tenant key in the url for showing the correct Logo before login
export const TENANT_URL_PARAM = 't';

// Define the Ui Master
export const MASTER_UI = '_master';

// Support email for this tenant
export const SUPPORT_EMAIL = 'bgpt-support@bayernwerk.de';

export default [
    {
        tenantKey: 'u6eo',
        debugName: 'Bayernwerk Netz GmbH',
        ui: 'u6eo',
        groups: ['5c28d457-f7e2-4cf6-9d96-e6426db749db','aaa8ac45-b927-4d30-aa70-bb04095f8ebe', adminGroup, devGroup],
    },
    {
        tenantKey: 'u6eo',
        debugName: 'Bayernwerk Netz GmbH (old)',
        ui: 'u6eo_deprecated',
        groups: [devGroup],
    },
];

/**
 * The URL to redirect users when they are not allowed access.
 *
 * This is the default redirect destination for users who do not have permission to access EN-GPT.
 *
 * @constant {string}
 */
export const NOT_ALLOWED_REDIRECT = 'https://genai.eon.com';
